import type { ProductLeaf, PropertyValue } from 'apps/commerce/types.ts'

export type SlimProductIsVariantOf = {
    hasVariant: Pick<ProductLeaf, 'additionalProperty' | 'url' | 'offers' | 'sku'>[]
    additionalProperty: PropertyValue[]
}
type SlimProduct = {
    isVariantOf?: {
        hasVariant: Pick<ProductLeaf, 'additionalProperty' | 'url' | 'offers'>[]
    }
}

const omit = new Set(['category', 'cluster', 'RefId', 'Modal Type'])

export const useVariantPossibilities = ({ isVariantOf }: SlimProduct) => {
    const allProperties = (isVariantOf?.hasVariant ?? [])
        .flatMap(({ additionalProperty = [], url, offers }) =>
            additionalProperty.map((property) => ({ property, url, offers }))
        )
        .filter((x) => x.url)
        .sort((a, b) => (a.url! < b.url! ? -1 : a.url === b.url ? 0 : 1))

    const possibilities = allProperties.reduce(
        (acc, { property, url, offers }) => {
            const { name = '', value = '' } = property
            const isAvailable = offers?.offers?.some((offer) => {
                return (
                    offer.availability === 'https://schema.org/InStock' ||
                    !!offer.inventoryLevel?.value
                )
            }) ?? false

            if (omit.has(name)) return acc

            if (!acc[name]) {
                acc[name] = {}
            }

            if (!acc[name][value]) {
                acc[name][value] = { isAvailable, urls: [] }
            }

            if (url) {
                acc[name][value] = {
                    isAvailable,
                    urls: [...acc[name][value].urls, url],
                }
            }

            return acc
        },
        {} as Record<string, Record<string, { isAvailable: boolean; urls: string[] }>>,
    )

    return possibilities
}
